const Swiper = window.Swiper;
window.addEventListener('load', function () {
  new Swiper('.fullwidth-header__carousel', {
    direction: 'horizontal',
    loop: true,
    autoplay: {
      delay: 7500,
      disableOnInteraction: true,
    },

    pagination: {
      el: '.fullwidth-header__carousel__navigation .swiper-pagination',
      clickable: 'true',
    },

    navigation: {
      nextEl: '.fullwidth-header__carousel__navigation .swiper-button-next',
      prevEl: '.fullwidth-header__carousel__navigation .swiper-button-prev',
    },

    on: {
      init: function () {
        document
          .querySelectorAll(
            '.swiper-slide-duplicate h1.fullwidth-header__slide__title'
          )
          .forEach(function (h1) {
            const p = document.createElement('p');
            p.className = h1.className;
            p.innerHTML = h1.innerHTML;
            h1.replaceWith(p);
          });
      },
    },
  });
});
